import { Shield } from 'lucide-react';

export default function Terms() {
  return (
    <div className="page-transition pt-20" data-testid="terms-page">
      <section className="section-padding">
        <div className="container-main">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 bg-[#E8F5E9] text-[#2E7D32] px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Shield className="w-4 h-4" />
                Legal
              </div>
              <h1 className="text-4xl sm:text-5xl font-bold text-[#1A1C1A] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Terms & Conditions
              </h1>
              <p className="text-[#52525B]">Last Updated: December 2024</p>
            </div>

            <div className="prose prose-lg max-w-none text-[#52525B]">
              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>1. Agreement to Terms</h2>
              <p>
                By accessing or using the Primes Pick website and services, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>2. Services Description</h2>
              <p>
                Primes Pick provides professional pest control services for residential and commercial properties. Our services include but are not limited to general pest control, termite treatment, rodent control, bed bug treatment, and other pest management solutions.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>3. Service Appointments</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Service appointments are scheduled based on availability</li>
                <li>A 24-hour notice is required for cancellations or rescheduling</li>
                <li>Late cancellations may be subject to a service fee</li>
                <li>Property access must be provided at the scheduled time</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>4. Payment Terms</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Payment is due upon completion of service unless otherwise agreed</li>
                <li>We accept major credit cards, checks, and cash</li>
                <li>Prices are subject to change with notice</li>
                <li>Late payments may incur additional fees</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>5. Service Guarantee</h2>
              <p>
                We stand behind our work with a satisfaction guarantee. If pests return between scheduled treatments, we will re-treat the affected areas at no additional charge. This guarantee is subject to the following conditions:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Customer must maintain recommended treatment schedule</li>
                <li>Customer must follow preparation instructions provided</li>
                <li>Guarantee does not cover new infestations of different pest types</li>
                <li>Guarantee period varies by service type</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>6. Customer Responsibilities</h2>
              <p>Customers agree to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate information about pest problems and property conditions</li>
                <li>Follow all preparation instructions before treatments</li>
                <li>Notify us of any known allergies or sensitivities</li>
                <li>Secure pets during service appointments</li>
                <li>Provide safe access to treatment areas</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>7. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, Primes Pick shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from the use of our services. Our total liability shall not exceed the amount paid for the specific service giving rise to the claim.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>8. Intellectual Property</h2>
              <p>
                All content on this website, including text, graphics, logos, and images, is the property of Primes Pick and is protected by intellectual property laws. Unauthorized use is prohibited.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>9. Website Use</h2>
              <p>You agree not to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Use the website for any unlawful purpose</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Interfere with the proper functioning of the website</li>
                <li>Copy, modify, or distribute website content without permission</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>10. Indemnification</h2>
              <p>
                You agree to indemnify and hold harmless Primes Pick, its officers, directors, employees, and agents from any claims, damages, losses, or expenses arising from your use of our services or violation of these terms.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>11. Governing Law</h2>
              <p>
                These Terms and Conditions shall be governed by and construed in accordance with the laws of the State of Minnesota, without regard to its conflict of law provisions.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>12. Changes to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to the website. Your continued use of our services constitutes acceptance of the modified terms.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>13. Contact Information</h2>
              <p>For questions about these Terms and Conditions, please contact us:</p>
              <ul className="list-none space-y-2 mt-4">
                <li><strong>Email:</strong> support@primespick.store</li>
                <li><strong>Phone:</strong> +1-888-356-8891</li>
                <li><strong>Address:</strong> 1284 Silver Lake Road, Minneapolis, MN 44401</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
